import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewEncapsulation,
  AfterViewChecked,
  OnInit,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import {
  FormButtonElementItem,
  FormData,
  FormDataItem,
  FormElementItem,
} from '../../interfaces/form-data';
import * as MAPS from './maps';
import { DynamicFormService } from 'src/app/services/dynamic-form.service';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { SnackAlertService } from 'src/app/services/snack-alert.service';
import {
  faCircleInfo,
  faSpinner,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'DD MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD MMMM YYYY',
  },
};

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DynamicFormComponent implements AfterViewChecked, OnInit {
  @Input() formName!: string;
  @Input() formData!: FormData;
  @Input() form!: FormData;
  @Input() disabled!: boolean;
  @Input() submitButton!: string;
  @Input() customFunctions!: any;
  // @Input() customFunctions!: { [name: string]: (fieldOrElement: FormDataItem | FormElementItem, formData: FormData, dynamicForm: DynamicFormComponent) => void };

  @ViewChild('dtpicker') dtpicker: any;
  @ViewChild('dpicker') dpicker: any;

  @Output() formSubmit = new EventEmitter<{
    formData: FormData;
    valid: boolean;
  }>();
  @Output()
  formChange = new EventEmitter<{
    formData: FormData;
    valid: boolean;
  }>();
  @Output() formValidation = new EventEmitter<boolean>();

  @ViewChild('dynamicForm', {
    static: true,
  })
  private readonly dynamicForm!: NgForm;

  public maps = MAPS;
  faCircleInfo = faCircleInfo;
  faSpinner = faSpinner;
  faCircleXmark = faCircleXmark;

  @Input() subFormsValidationStatus: { [index: string]: any } = {};

  constructor(
    private readonly dfService: DynamicFormService,
    private readonly alertService: SnackAlertService
  ) { }

  @Input()
  submit(): void {
    const elements = window.document.getElementsByClassName(
      'invisible-submit-button'
    );
    const elementsArray = Array.from(elements);
    for (const element of elementsArray) {
      (element as any).click();
    }
  }

  ngOnInit(): void {
    this.formData && this.execFormFieldsOnInit(this.formData);
  }

  ngAfterViewChecked() {
    this.formValidation.emit(this.isValid());
  }

  private execFormFieldsOnInit(formData: FormData) {
    let payload = this.form;
    formData.fields.forEach((field) => {
      if (field.type !== 'form') {
        this.execFormFieldItemsUrl(field, payload);
        this.execFormFieldOnInit(field);
      }
    });
  }

  /**
   * Add-Remove value of radio/checkboxes input
   * @param field field Object
   * @param itemValue item value to remove/add
   */
  onCheckboxChange(field: FormDataItem, itemValue: any) {
    let index = -1;
    if (typeof field.value === 'object') {
      index = field.value.indexOf(itemValue);
    }

    index > -1 ? field.value.splice(index, 1) : field.value.push(itemValue);

    this.validationError(field);

    this.onChange();
  }

  getFieldByName(name: string) {
    return this.formData.fields.find((field) => field.name === name);
  }

  /**
   * Check if radio or checkbox is checked
   * @param fieldValue field value
   * @param itemValue item value
   * @returns boolean
   */
  isCheckboxChecked(fieldValue: any, itemValue: any) {
    return fieldValue.includes(itemValue);
  }

  /**
   * event called on change input file
   * @param event event object
   * @param field field where event is fired
   */
  onChangeFile(event: any, field: FormDataItem) {
    const filesIns: File | undefined = event.target.files?.[0];
    const element = event.target;
    const url: string = event.target.value;
    const controlForm = this.dynamicForm.controls[field.name];
    const errors = controlForm.errors || {};
    if (filesIns) {
      // set file name in input text (setting label)
      element.nextElementSibling.innerText = filesIns.name;

      // check file size (in kb)
      if (filesIns.size / 1024 > field.maxSize!) {
        controlForm.setErrors({
          ...errors,
          [MAPS.INPUT_CUSTOM_ERRORS.MAX_SIZE]: true,
        });
      }
      // check file mime type
      if (!field.allowedMimeTypes!.includes(filesIns.type)) {
        controlForm.setErrors({
          ...errors,
          [MAPS.INPUT_CUSTOM_ERRORS.FILE_TYPE]: true,
        });
      }

      //if valid load file and fill formData
      if (controlForm.valid) {
        const reader = new FileReader();
        reader.onload = (e: any) => {







          const result = reader.result;

          // Ensure result is a string before calling .split()
          if (typeof result === 'string') {
            const data: string = result.split(',')[1];
            const mimeType: string = filesIns.type;

            this.formData.fields.forEach((fieldData: FormDataItem) => {
              if (fieldData.name === field.name) {
                fieldData.value = {
                  url,
                  mimeType,
                  data,
                };
              }
            });
            // call onChange and emit dataForm eventEmitter
            this.onChange();
            this.execFormFieldOnChange(field);
          } else {
            console.error('File content is not a string');
          }
        };

        // catch error
        reader.onerror = (event) => {
          reader.abort();
          console.log(reader.error!.message);
        };

        reader.readAsDataURL(filesIns);
      }
    } else {
      // on 'annulla' or no file selected
      event.target.nextElementSibling.innerText = field.label;
    }
  }
  /**
   * emit value every change
   */
  onChange() {
    this.formChange.emit({
      formData: this.formData,
      valid: this.isValid(),
    });
    this.formValidation.emit(this.isValid());
  }

  onSubFormChange(formName: string, isValid: any) {
    this.onChange();
  }

  onSubFormValidation(formName: string, isValid: boolean) {
    this.formValidation.emit(this.isValid());
  }

  isValid(): boolean {
    return !Object.keys(this.subFormsValidationStatus).some(
      (k) => !this.subFormsValidationStatus[k]
    );
  }

  /**
   * Set ISO format to datetime field
   * @param data new data changed
   * @param fieldName name of the field
   * @returns formData with correct format for datetimepicker
   */
  changeDatetimepicker(data: any, fieldName: string) {
    this.formData.fields = this.formData.fields.map((field: FormDataItem) => {
      // only for datetime filed
      if (field.name === fieldName) {
        field.value = new Date(data.value).toISOString();
      }
      return field;
    });

    this.onChange();
  }

  /**
   * check if is multiple choise or not
   * @param field check if list is multiple or not
   * @returns boolean
   */
  isMultiple(field: FormDataItem): boolean {
    if ('min' in field || 'max' in field) {
      return field.min !== field.max;
    } else {
      return false;
    }
  }

  onFormSubmit() {
    this.formSubmit.emit({ formData: this.formData, valid: this.isValid() });
  }

  /**
   * Check the validity of fields excluded Datatimepicker because it has own validation method
   * @param field formData field to validate
   * @returns boolean and set custom errors
   */
  validationError(field: FormDataItem): boolean {
    let invalid = false;
    const controlForm = this.dynamicForm.form.controls[field.name];

    if (this.dynamicForm.submitted && !this.isFormFieldHidden(field)) {
      if (typeof controlForm !== 'undefined') {
        if (controlForm.invalid) {
          invalid = true;
        }

        // check multiple value (for type list checkbox)
        if (Array.isArray(field.value)) {
          invalid = this.checkTooFewValues(field, controlForm, invalid);
          invalid = this.checkTooManyValues(field, controlForm, invalid);
          invalid = this.checkEmptyValues(field, controlForm, invalid);
        } else if (field.widget === 'radios') {
          // check radio required
          invalid = this.checkRadioRequired(field, controlForm, invalid);
        } else if (field.type !== this.maps.FIELD_TYPES.dateTime) {
          // we exclude datetimepicker because it has own validation
          // validation for type number with min/man attributes
          invalid = this.checkRangeTime(field, controlForm, invalid);
        }

        // chenge the control status if errors are empty status
        invalid = this.checkError(controlForm, invalid);
      }
    }
    this.subFormsValidationStatus[field.name] = !invalid;
    return invalid;
  }

  private checkTooFewValues(field: any, controlForm: any, invalid: boolean) {
    if (field.min && +field.min >= 0 && field.value.length < +field.min) {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW]: true,
      });
      invalid = true;
    } else if (
      controlForm.errors?.[MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW]
    ) {
      delete controlForm.errors[MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW];
    }

    return invalid;
  }

  private checkTooManyValues(field: any, controlForm: any, invalid: boolean) {
    if (field.max && +field.max >= 0 && field.value.length > +field.max) {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY]: true,
      });
      invalid = true;
    } else if (
      controlForm.errors?.[MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY]
    ) {
      delete controlForm.errors[MAPS.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY];
    }
    return invalid;
  }

  private checkEmptyValues(field: any, controlForm: any, invalid: boolean) {
    if (field.value.length === 0 && field.required) {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.REQUIRED]: true,
      });
      invalid = true;
    } else if (
      controlForm.errors?.[MAPS.INPUT_CUSTOM_ERRORS.REQUIRED]
    ) {
      delete controlForm.errors[MAPS.INPUT_CUSTOM_ERRORS.REQUIRED];
    }
    return invalid;
  }

  private checkRadioRequired(field: any, controlForm: any, invalid: boolean) {
    if (this.dynamicForm.submitted && field.required && field.value === '') {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.REQUIRED]: true,
      });
      invalid = true;
    }
    return invalid;
  }

  private checkRangeTime(field: any, controlForm: any, invalid: boolean) {
    if (
      'max' in field &&
      field.max &&
      this.dynamicForm.submitted &&
      field.value &&
      field.value > field.max
    ) {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.RANGE_OVER]: true,
      });
      invalid = true;
    }

    if (
      'min' in field &&
      field.min &&
      this.dynamicForm.submitted &&
      field.value &&
      field.value < field.min
    ) {
      controlForm.setErrors({
        [MAPS.INPUT_CUSTOM_ERRORS.RANGE_UNDER]: true,
      });
      invalid = true;
    }
    return invalid;
  }

  private checkError(controlForm: any, invalid: boolean) {
    if (
      controlForm.hasOwnProperty('errors') &&
      JSON.stringify(controlForm.errors) === '{}'
    ) {
      invalid = false;
      controlForm.clearValidators();
      controlForm.updateValueAndValidity();
    }
    return invalid;
  }

  private getFormDataValues(formData: FormData) {
    const values: { [index: string]: any } = {};

    const setCustomFunctions = (fieldOrElementName: string) => {
      if (this.customFunctions) {
        for (const customFunctionName in this.customFunctions) {
          if (this.customFunctions.hasOwnProperty(customFunctionName)) {
            const customFunctionKey =
              fieldOrElementName + '_$' + customFunctionName;
            values[customFunctionKey] = (that: any) => {
              values[customFunctionKey + '_invoked'] = true;
            };
          }
        }
      }
    };

    formData.fields.forEach((field) => {
      if (field.type !== 'form') {
        values[field.name] = field.value;
      }
      setCustomFunctions(field.name);
    });

    this.getAllFormElementsNames(formData).forEach((elementName) => {
      setCustomFunctions(elementName);
    });

    return values;
  }

  private setFormDataValues(formData: FormData, values: any) {
    formData.fields.forEach((field) => {
      if (field.type !== 'form') {
        field.value = values[field.name];
      }
    });
  }

  private getAllFormFieldsAndElementsNames(formData: FormData): string[] {
    const fieldsNames: string[] = [];
    formData.fields.forEach((field) => {
      if (field.type !== 'form') {
        fieldsNames.push(field.name);
      }
    });

    const elementsNames = this.getAllFormElementsNames(formData);

    const names = ([] as string[]).concat(fieldsNames, elementsNames);
    return names;
  }

  private getAllFormElements(formData: FormData): FormElementItem[] {
    const a: any[] = [];
    const enumerateElements = (elements: FormElementItem[]) => {
      elements.forEach((element) => {
        a.push(element);
        if (element.elements) {
          enumerateElements(element.elements);
        }
      });
    };

    enumerateElements(formData.elements!);
    return a;
  }

  private getAllFormElementsNames(formData: FormData): string[] {
    return this.getAllFormElements(formData)
      .filter((e) => (e.name))
      .map((e: any) => e.name);
  }

  private getCustomFunctionsInvocations(
    formData: FormData,
    values: any
  ): { name: string; target: FormDataItem }[] {
    const invocations: any[] = [];

    const trackCustomFunctionsInvocations = (
      fieldOrElement: FormDataItem | FormElementItem
    ) => {
      if (this.customFunctions) {
        for (const customFunctionName in this.customFunctions) {
          if (this.customFunctions.hasOwnProperty(customFunctionName)) {
            const customFunctionKey =
              fieldOrElement.name + '_$' + customFunctionName;

            if (values[customFunctionKey + '_invoked'] === true) {
              invocations.push({
                name: customFunctionName,
                target: fieldOrElement,
              });
            }
          }
        }
      }
    };

    formData.fields.forEach((field) => {
      trackCustomFunctionsInvocations(field);
    });

    this.getAllFormElements(formData).forEach((elementName) => {
      trackCustomFunctionsInvocations(elementName);
    });

    return invocations;
  }

  private execExpressionInFormContext(
    expressionPrefix: string,
    expression: string,
    expressionSuffix: string,
    input: any,
    additionalData?: { [key: string]: any }
  ): any {
    const formFieldNames = this.getAllFormFieldsAndElementsNames(this.formData);

    let modifiedExpression = expression;
    for (const formFieldName of formFieldNames) {
      modifiedExpression = modifiedExpression.replace(
        new RegExp('\\b' + formFieldName + '\\b', 'g'),
        'this.' + formFieldName
      );
      modifiedExpression = modifiedExpression.replace(
        new RegExp(formFieldName + '\\.\\$', 'g'),
        formFieldName + '_$'
      );
    }

    modifiedExpression = modifiedExpression.replace(/\(\)/gm, '(this)');

    const additionalArgsNames = additionalData
      ? Object.keys(additionalData)
      : [];
    const additionalArgsValues = additionalData
      ? Object.values(additionalData)
      : [];

    const output = new Function(
      ...(additionalArgsNames || []),
      expressionPrefix + modifiedExpression + expressionSuffix
    )?.apply(input, additionalArgsValues);

    return output;
  }

  @Input()
  execExpression(
    expression: string,
    additionalArguments?: { [key: string]: any }
  ): void {
    const formDataValues = this.getFormDataValues(this.formData);
    const updatedFormDataValues = this.execExpressionInFormContext(
      '',
      expression,
      ';return this;',
      formDataValues,
      additionalArguments
    );
    this.setFormDataValues(this.formData, updatedFormDataValues);
    this.onChange();

    const invocations = this.getCustomFunctionsInvocations(
      this.formData,
      updatedFormDataValues
    );
    for (const invocation of invocations) {
      this.customFunctions[invocation.name](
        invocation.target,
        this.formData,
        this
      );
    }
  }

  execFormFieldOnChange(field: FormDataItem) {
    if (!field.onChange) {
      return;
    }
    this.execExpression(field.onChange);
  }

  private execFormFieldItemsUrl(field: FormDataItem, payload: any) {
    if (!field.itemsUrl) {
      return;
    }
    field.loading = true;
    this.dfService
      .execItemsUrl(field.itemsUrl, payload)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
            field.error = true;
            this.alertService.openSnackBar(
              error.message || error.error.error.message,
              'error-snackbar',
              3000,
              'Chiudi'
            );
          });
        })
      )
      .subscribe((data: any) => {
        field.items = data;
        field.loading = false;
      });
  }

  private execFormFieldOnInit(field: FormDataItem) {
    if (!field.onInit) {
      return;
    }
    this.execExpression(field.onInit);
  }

  execFormElementOnClick(element: FormButtonElementItem) {
    if (!element.onClick) {
      return;
    }
    this.execExpression(element.onClick);
  }

  isFormFieldDisabled(field: FormDataItem): boolean {
    if (!field.disabled) {
      return false;
    }
    const formDataValues = this.getFormDataValues(this.formData);
    return this.execExpressionInFormContext(
      'return ',
      field.disabled,
      '',
      formDataValues
    );
  }

  isFormFieldHidden(field: FormDataItem): boolean {
    if (!field.hidden) {
      return false;
    }
    const formDataValues = this.getFormDataValues(this.formData);
    return this.execExpressionInFormContext(
      'return ',
      field.hidden,
      '',
      formDataValues
    );
  }
}
